import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import slugify from 'slugify'
import { withRouter, Link } from 'react-router-dom'
import HighLevelCard from './HighLevelCard'

class HighLevelCategories extends Component {
  render() {
    const { categories, headingDescription } = this.props
    const param = this.props.match.params.frameworkName;
    return (
      <div className="content__high_level_category">
        <Row>
          <Col md={12} id='highLevelCategoryHeading'>
            <h3 className='page-title'>High Level Categories</h3>
            <h3 className='page-subhead subhead'>
              <strong>{headingDescription || 'All your compliance details in one view!'}</strong>
            </h3>
          </Col>
        </Row>
        <Row>
          {categories.map((category, idx) => {
            //const applicableControls = category.numberOfControls - category.numberOfNotApplicableControls;
            let url = '';
            url += param ? `/${param}` : '';
            url += `/${slugify(category.name)}/`;
            return (
              <Link
                className="col-md-12 col-lg-4"
                key={idx}
                to={`/app/control_content${url.toLowerCase()}`}
              >
                <HighLevelCard
                  id={slugify(category.name.toUpperCase())}
                  title={category.name.toUpperCase()}
                  description={category.description ? category.description :
                  'A prioritized set of actions to protect your organization and data from known cyber attack vendors'}
                  clickable
                  hoverColor
                  isActive={false}
                  bgColor='white-bg'
                />
              </Link>)
          }
          )}
        </Row>
      </div>
    )
  }
}

export default withRouter(HighLevelCategories)



// WEBPACK FOOTER //
// ./src/components/content_management/HighLevelCategories.js